import { useState } from 'react'

const getPlacowkaId = placowka => placowka?._id || placowka?.id

export default function usePlacowkiSelection() {
	const [selectedPlacowki, setSelectedPlacowki] = useState(new Set())

	const handleSelectAll = (checked, placowkiData) => {
		if (checked) {
			setSelectedPlacowki(new Set(placowkiData.map(getPlacowkaId).filter(Boolean)))
		} else {
			setSelectedPlacowki(new Set())
		}
	}

	const handleSelectPlacowka = (placowkaId, checked) => {
		const next = new Set(selectedPlacowki)
		if (checked) {
			next.add(placowkaId)
		} else {
			next.delete(placowkaId)
		}
		setSelectedPlacowki(next)
	}

	const clearSelection = () => setSelectedPlacowki(new Set())

	const getSelectionState = placowkiData => {
		const total = placowkiData.length
		const selectedCount = selectedPlacowki.size
		return {
			isAllSelected: total > 0 && selectedCount === total,
			isIndeterminate: selectedCount > 0 && selectedCount < total,
		}
	}

	return {
		selectedPlacowki,
		handleSelectAll,
		handleSelectPlacowka,
		clearSelection,
		getSelectionState,
	}
}
